/**
 * AccordionController
 * js-accordion クラスを持つ要素を自動初期化する
 *
 * HTML構造:
 * <div class="js-accordion">
 *   <button class="js-accordion-trigger">質問</button>
 *   <div class="js-accordion-body">回答</div>
 * </div>
 */
export const AccordionController = {
  init() {
    const triggers = document.querySelectorAll( '.js-accordion-trigger' );
    triggers.forEach( ( trigger ) => {
      trigger.addEventListener( 'click', () => {
        const isOpen = trigger.getAttribute( 'aria-expanded' ) === 'true';
        const body   = trigger.closest( '.js-accordion' )?.querySelector( '.js-accordion-body' );
        if ( !body ) return;

        trigger.setAttribute( 'aria-expanded', String( !isOpen ) );
        trigger.closest( '.js-accordion' ).classList.toggle( 'is-open', !isOpen );

        if ( !isOpen ) {
          body.style.height = body.scrollHeight + 'px';
        } else {
          body.style.height = '0';
        }
      } );
    } );
  },
};
